document.addEventListener('DOMContentLoaded', () => {
  const sb = document.querySelector('.sbboxes');
  const icons = document.querySelectorAll('.mobile_icon_make_modal');
  if (!sb) return;

  icons.forEach(icon => icon.addEventListener('click', () => {
    if (window.innerWidth >= 767) return;
    sb.classList.toggle('showBox');
    icon.classList.toggle('rotated');
  }));

  window.addEventListener('resize', () => {
    if (window.innerWidth >= 767) {
      sb.classList.remove('showBox');
      icons.forEach(icon => icon.classList.remove('rotated'));
    }
  });
});

 function onMakeChange() {
    var make = document.getElementById('make').value;
    if (make === 'Ford') {
      document.getElementById('model').disabled = false;
      document.getElementById('model').innerHTML =
        '<option value="none">Select a Model</option>' +
        '<option value="F-150">F-150</option>' +
        '<option value="F-150 Lightning">F-150 Lightning</option>' +
        '<option value="F-150 RAPTOR">F-150 RAPTOR</option>' +
        '<option value="Superduty F-250">Superduty F-250</option>' +
        '<option value="Superduty F-350">Superduty F-350</option>' +
        '<option value="Superduty F-450">Superduty F-450</option>' +
        '<option value="Superduty F-550">Superduty F-550</option>' +
        '<option value="Superduty F-650">Superduty F-650</option>' +
        '<option value="Bronco">Bronco</option>' +
        '<option value="Excursion">Excursion</option>' +
        '<option value="Expedition">Expedition</option>' +
        '<option value="Maverick">Maverick</option>' +
        '<option value="Mustang">Mustang</option>' +
        '<option value="Ranger">Ranger</option>' +
        '<option value="Sport-Trac">Sport-Trac</option>';
    } else if (make === 'Dodge+%28RAM%29&') {
      document.getElementById('model').disabled = false;
      document.getElementById('model').innerHTML =
        '<option value="none">Select a Model</option>' +
        '<option value="RAM+1500">RAM 1500</option>' +
        '<option value="RAM+1500+Classic+Body">RAM 1500 Classic Body</option>' +
        '<option value="RAM+2500">RAM 2500</option>' +
        '<option value="RAM+3500">RAM 3500</option>';
    } else if (make === 'Chevy') {
      document.getElementById('model').disabled = false;
      document.getElementById('model').innerHTML =
        '<option value="none">Select a Model</option>' +
        '<option value="Avalanche">Avalanche</option>' +
        '<option value="Silverado 1500">Silverado 1500</option>' +
        '<option value="Silverado 2500">Silverado 2500</option>' +
        '<option value="Silverado 3500">Silverado 3500</option>' +
        '<option value="Silverado 3500 Dually">Silverado 3500 Dually</option>' +
        '<option value="Suburban">Suburban</option>' +
        '<option value="Tahoe">Tahoe</option>';
    } else if (make === 'GMC') {
      document.getElementById('model').disabled = false;
      document.getElementById('model').innerHTML =
        '<option value="none">Select a Model</option>' +
        '<option value="Sierra+1500">Sierra 1500</option>' +
        '<option value="Sierra+2500">Sierra 2500</option>' +
        '<option value="Sierra+3500">Sierra 3500</option>' +
        '<option value="Sierra+3500+Dually">Sierra 3500 Dually</option>' +
        '<option value="Tahoe">Tahoe</option>' +
        '<option value="Yukon">Yukon</option>' +
        '<option value="Yukon XL">Yukon XL</option>' +
        '<option value="Yukon Denali">Yukon Denali</option>' +
        '<option value="Hummer EV">Hummer EV</option>';
    } else if (make === 'Jeep') {
      document.getElementById('model').disabled = false;
      document.getElementById('model').innerHTML =
        '<option value="none">Select a Model</option>' +
        '<option value="Wrangler+JL">Wrangler JL</option>' +
        '<option value="Wrangler+JK">Wrangler JK</option>' +
        '<option value="gladiator">Gladiator</option>';
    } else if (make === 'Toyota') {
      document.getElementById('model').disabled = false;
      document.getElementById('model').innerHTML =
        '<option value="none">Select a Model</option>' +
        '<option value="Sequoia">Sequoia</option>' +
        '<option value="Tacoma">Tacoma</option>' +
        '<option value="Tundra">Tundra</option>';
    } else if (make === 'Hummer') {
      document.getElementById('model').disabled = false;
      document.getElementById('model').innerHTML =
        '<option value="none">Select a Model</option>' + '<option value="H2">H2</option>';
    } else if (make === 'Cadillac') {
      document.getElementById('model').disabled = false;
      document.getElementById('model').innerHTML =
        '<option value="none">Select a Model</option>' + '<option value="Escalade">Escalade</option>';
    } else {
      document.getElementById('model').disabled = true;
      document.getElementById('model').innerHTML = '<option value="none">Select a Model</option>';
    }
  }
  document.getElementById('make').addEventListener('change', onMakeChange);
  function onModelChange() {
    var model = document.getElementById('model').value;
    if (model === 'F-150') {
      document.getElementById('year').disabled = false;
      document.getElementById('year').innerHTML =
        '<option value="none">Select a Year</option>' +
        '<option value="2025">2025</option>' +
        '<option value="2024">2024</option>' +
        '<option value="2023">2023</option>' +
        '<option value="2022">2022</option>' +
        '<option value="2021">2021</option>' +
        '<option value="2020">2020</option>' +
        '<option value="2019">2019</option>' +
        '<option value="2018">2018</option>' +
        '<option value="2017">2017</option>' +
        '<option value="2016">2016</option>' +
        '<option value="2015">2015</option>' +
        '<option value="2014">2014</option>' +
        '<option value="2013">2013</option>' +
        '<option value="2012">2012</option>' +
        '<option value="2011">2011</option>' +
        '<option value="2010">2010</option>' +
        '<option value="2009">2009</option>' +
        '<option value="2008">2008</option>' +
        '<option value="2007">2007</option>' +
        '<option value="2006">2006</option>' +
        '<option value="2005">2005</option>' +
        '<option value="2004">2004</option>' +
        '<option value="2003">2003</option>' +
        '<option value="2002">2002</option>' +
        '<option value="2001">2001</option>' +
        '<option value="2000">2000</option>' +
        '<option value="1999">1999</option>' +
        '<option value="1998">1998</option>' +
        '<option value="1997">1997</option>';
    } else if (model === 'F-150 Lightning') {
      document.getElementById('year').disabled = false;
      document.getElementById('year').innerHTML =
        '<option value="none">Select a Year</option>' +
        '<option value="2025">2025</option>' +
        '<option value="2024">2024</option>' +
        '<option value="2023">2023</option>' +
        '<option value="2022">2022</option>';
    } else if (model === 'F-150 RAPTOR') {
      document.getElementById('year').disabled = false;
      document.getElementById('year').innerHTML =
        '<option value="none">Select a Year</option>' +
        '<option value="2025">2025</option>' +
        '<option value="2024">2024</option>' +
        '<option value="2023">2023</option>' +
        '<option value="2022">2022</option>' +
        '<option value="2021">2021</option>' +
        '<option value="2020">2020</option>' +
        '<option value="2019">2019</option>' +
        '<option value="2018">2018</option>' +
        '<option value="2017">2017</option>' +
        '<option value="2016">2016</option>' +
        '<option value="2015">2015</option>' +
        '<option value="2014">2014</option>' +
        '<option value="2013">2013</option>' +
        '<option value="2012">2012</option>' +
        '<option value="2011">2011</option>' +
        '<option value="2010">2010</option>';
    } else if (model === 'Superduty F-250') {
      document.getElementById('year').disabled = false;
      document.getElementById('year').innerHTML =
        '<option value="none">Select a Year</option>' +
        '<option value="2025">2025</option>' +
        '<option value="2024">2024</option>' +
        '<option value="2023">2023</option>' +
        '<option value="2022">2022</option>' +
        '<option value="2021">2021</option>' +
        '<option value="2020">2020</option>' +
        '<option value="2019">2019</option>' +
        '<option value="2018">2018</option>' +
        '<option value="2017">2017</option>' +
        '<option value="2016">2016</option>' +
        '<option value="2015">2015</option>' +
        '<option value="2014">2014</option>' +
        '<option value="2013">2013</option>' +
        '<option value="2012">2012</option>' +
        '<option value="2011">2011</option>' +
        '<option value="2010">2010</option>' +
        '<option value="2009">2009</option>' +
        '<option value="2008">2008</option>' +
        '<option value="2007">2007</option>' +
        '<option value="2006">2006</option>' +
        '<option value="2005">2005</option>' +
        '<option value="2004">2004</option>' +
        '<option value="2003">2003</option>' +
        '<option value="2002">2002</option>' +
        '<option value="2001">2001</option>' +
        '<option value="2000">2000</option>' +
        '<option value="1999">1999</option>';
    } else if (model === 'Superduty F-350') {
      document.getElementById('year').disabled = false;
      document.getElementById('year').innerHTML =
        '<option value="none">Select a Year</option>' +
        '<option value="2025">2025</option>' +
        '<option value="2024">2024</option>' +
        '<option value="2023">2023</option>' +
        '<option value="2022">2022</option>' +
        '<option value="2021">2021</option>' +
        '<option value="2020">2020</option>' +
        '<option value="2019">2019</option>' +
        '<option value="2018">2018</option>' +
        '<option value="2017">2017</option>' +
        '<option value="2016">2016</option>' +
        '<option value="2015">2015</option>' +
        '<option value="2014">2014</option>' +
        '<option value="2013">2013</option>' +
        '<option value="2012">2012</option>' +
        '<option value="2011">2011</option>' +
        '<option value="2010">2010</option>' +
        '<option value="2009">2009</option>' +
        '<option value="2008">2008</option>' +
        '<option value="2007">2007</option>' +
        '<option value="2006">2006</option>' +
        '<option value="2005">2005</option>' +
        '<option value="2004">2004</option>' +
        '<option value="2003">2003</option>' +
        '<option value="2002">2002</option>' +
        '<option value="2001">2001</option>' +
        '<option value="2000">2000</option>' +
        '<option value="1999">1999</option>';
    } else if (model === 'Superduty F-450') {
      document.getElementById('year').disabled = false;
      document.getElementById('year').innerHTML =
        '<option value="none">Select a Year</option>' +
        '<option value="2025">2025</option>' +
        '<option value="2024">2024</option>' +
        '<option value="2023">2023</option>' +
        '<option value="2022">2022</option>' +
        '<option value="2021">2021</option>' +
        '<option value="2020">2020</option>' +
        '<option value="2019">2019</option>' +
        '<option value="2018">2018</option>' +
        '<option value="2017">2017</option>' +
        '<option value="2016">2016</option>' +
        '<option value="2015">2015</option>' +
        '<option value="2014">2014</option>' +
        '<option value="2013">2013</option>' +
        '<option value="2012">2012</option>' +
        '<option value="2011">2011</option>' +
        '<option value="2010">2010</option>' +
        '<option value="2009">2009</option>' +
        '<option value="2008">2008</option>' +
        '<option value="2007">2007</option>' +
        '<option value="2006">2006</option>' +
        '<option value="2005">2005</option>' +
        '<option value="2004">2004</option>' +
        '<option value="2003">2003</option>' +
        '<option value="2002">2002</option>' +
        '<option value="2001">2001</option>' +
        '<option value="2000">2000</option>' +
        '<option value="1999">1999</option>';
    } else if (model === 'Superduty F-550') {
      document.getElementById('year').disabled = false;
      document.getElementById('year').innerHTML =
        '<option value="none">Select a Year</option>' +
        '<option value="2025">2025</option>' +
        '<option value="2024">2024</option>' +
        '<option value="2023">2023</option>' +
        '<option value="2022">2022</option>' +
        '<option value="2021">2021</option>' +
        '<option value="2020">2020</option>' +
        '<option value="2019">2019</option>' +
        '<option value="2018">2018</option>' +
        '<option value="2017">2017</option>' +
        '<option value="2016">2016</option>' +
        '<option value="2015">2015</option>' +
        '<option value="2014">2014</option>' +
        '<option value="2013">2013</option>' +
        '<option value="2012">2012</option>' +
        '<option value="2011">2011</option>' +
        '<option value="2010">2010</option>' +
        '<option value="2009">2009</option>' +
        '<option value="2008">2008</option>' +
        '<option value="2007">2007</option>' +
        '<option value="2006">2006</option>' +
        '<option value="2005">2005</option>' +
        '<option value="2004">2004</option>' +
        '<option value="2003">2003</option>' +
        '<option value="2002">2002</option>' +
        '<option value="2001">2001</option>' +
        '<option value="2000">2000</option>' +
        '<option value="1999">1999</option>';
    } else if (model === 'Superduty F-650') {
      document.getElementById('year').disabled = false;
      document.getElementById('year').innerHTML =
        '<option value="none">Select a Year</option>' +
        '<option value="2025">2025</option>' +
        '<option value="2024">2024</option>' +
        '<option value="2023">2023</option>' +
        '<option value="2022">2022</option>' +
        '<option value="2021">2021</option>' +
        '<option value="2020">2020</option>' +
        '<option value="2019">2019</option>' +
        '<option value="2018">2018</option>' +
        '<option value="2017">2017</option>' +
        '<option value="2016">2016</option>' +
        '<option value="2015">2015</option>' +
        '<option value="2014">2014</option>' +
        '<option value="2013">2013</option>' +
        '<option value="2012">2012</option>' +
        '<option value="2011">2011</option>' +
        '<option value="2010">2010</option>' +
        '<option value="2009">2009</option>' +
        '<option value="2008">2008</option>' +
        '<option value="2007">2007</option>' +
        '<option value="2006">2006</option>' +
        '<option value="2005">2005</option>' +
        '<option value="2004">2004</option>' +
        '<option value="2003">2003</option>' +
        '<option value="2002">2002</option>' +
        '<option value="2001">2001</option>' +
        '<option value="2000">2000</option>' +
        '<option value="1999">1999</option>';
    } else if (model === 'Maverick') {
      document.getElementById('year').disabled = false;
      document.getElementById('year').innerHTML =
        '<option value="none">Select a Year</option>' +
        '<option value="2024">2024</option>' +
        '<option value="2023">2023</option>' +
        '<option value="2022">2022</option>';
    } else if (model === 'Hummer EV') {
      document.getElementById('year').disabled = false;
      document.getElementById('year').innerHTML =
        '<option value="none">Select a Year</option>' +
        '<option value="2025">2025</option>' +
        '<option value="2024">2024</option>' +
        '<option value="2023">2023</option>' +
        '<option value="2022">2022</option>';
    } else if (model === 'Ranger') {
      document.getElementById('year').disabled = false;
      document.getElementById('year').innerHTML =
        '<option value="none">Select a Year</option>' +
        '<option value="2025">2025</option>' +
        '<option value="2024">2024</option>' +
        '<option value="2023">2023</option>' +
        '<option value="2022">2022</option>' +
        '<option value="2021">2021</option>' +
        '<option value="2020">2020</option>' +
        '<option value="2019">2019</option>' +
        '<option value="2018">2018</option>' +
        '<option value="2017">2017</option>' +
        '<option value="2016">2016</option>' +
        '<option value="2015">2015</option>' +
        '<option value="2014">2014</option>' +
        '<option value="2013">2013</option>' +
        '<option value="2012">2012</option>' +
        '<option value="2011">2011</option>' +
        '<option value="2010">2010</option>' +
        '<option value="2009">2009</option>' +
        '<option value="2008">2008</option>' +
        '<option value="2007">2007</option>' +
        '<option value="2006">2006</option>' +
        '<option value="2005">2005</option>' +
        '<option value="2004">2004</option>' +
        '<option value="2003">2003</option>' +
        '<option value="2002">2002</option>' +
        '<option value="2001">2001</option>' +
        '<option value="2000">2000</option>' +
        '<option value="1999">1999</option>' +
        '<option value="1998">1998</option>' +
        '<option value="1997">1997</option>' +
        '<option value="1996">1996</option>' +
        '<option value="1995">1995</option>';
    } else if (model === 'Bronco') {
      document.getElementById('year').disabled = false;
      document.getElementById('year').innerHTML =
        '<option value="none">Select a Year</option>' +
        '<option value="2025">2025</option>' +
        '<option value="2024">2024</option>' +
        '<option value="2023">2023</option>' +
        '<option value="2022">2022</option>' +
        '<option value="2021">2021</option>';
    } else if (model === 'Sport-Trac') {
      document.getElementById('year').disabled = false;
      document.getElementById('year').innerHTML =
        '<option value="none">Select a Year</option>' +
        '<option value="2016">2016</option>' +
        '<option value="2015">2015</option>' +
        '<option value="2014">2014</option>' +
        '<option value="2013">2013</option>' +
        '<option value="2012">2012</option>' +
        '<option value="2011">2011</option>' +
        '<option value="2010">2010</option>' +
        '<option value="2009">2009</option>' +
        '<option value="2008">2008</option>' +
        '<option value="2007">2007</option>' +
        '<option value="2006">2006</option>' +
        '<option value="2005">2005</option>' +
        '<option value="2004">2004</option>' +
        '<option value="2003">2003</option>' +
        '<option value="2002">2002</option>' +
        '<option value="2001">2001</option>';
    } else if (model === 'Excursion') {
      document.getElementById('year').disabled = false;
      document.getElementById('year').innerHTML =
        '<option value="none">Select a Year</option>' +
        '<option value="2007">2007</option>' +
        '<option value="2006">2006</option>' +
        '<option value="2005">2005</option>' +
        '<option value="2004">2004</option>' +
        '<option value="2003">2003</option>' +
        '<option value="2002">2002</option>' +
        '<option value="2001">2001</option>' +
        '<option value="2000">2000</option>';
    } else if (model === 'Expedition') {
      document.getElementById('year').disabled = false;
      document.getElementById('year').innerHTML =
        '<option value="none">Select a Year</option>' +
        '<option value="2013">2013</option>' +
        '<option value="2012">2012</option>' +
        '<option value="2011">2011</option>' +
        '<option value="2010">2010</option>' +
        '<option value="2009">2009</option>' +
        '<option value="2008">2008</option>' +
        '<option value="2007">2007</option>' +
        '<option value="2006">2006</option>' +
        '<option value="2005">2005</option>' +
        '<option value="2004">2004</option>' +
        '<option value="2003">2003</option>' +
        '<option value="2002">2002</option>' +
        '<option value="2001">2001</option>' +
        '<option value="2000">2000</option>' +
        '<option value="1999">1999</option>' +
        '<option value="1998">1998</option>' +
        '<option value="1997">1997</option>';
    } else if (model === 'Mustang') {
      document.getElementById('year').disabled = false;
      document.getElementById('year').innerHTML =
        '<option value="none">Select a Year</option>' +
        '<option value="2017">2017</option>' +
        '<option value="2016">2016</option>' +
        '<option value="2015">2015</option>' +
        '<option value="2014">2014</option>' +
        '<option value="2013">2013</option>' +
        '<option value="2012">2012</option>' +
        '<option value="2011">2011</option>' +
        '<option value="2010">2010</option>' +
        '<option value="2009">2009</option>' +
        '<option value="2008">2008</option>' +
        '<option value="2007">2007</option>' +
        '<option value="2006">2006</option>' +
        '<option value="2005">2005</option>';
    } else if (model === 'RAM+1500') {
      document.getElementById('year').disabled = false;
      document.getElementById('year').innerHTML =
        '<option value="none">Select a Year</option>' +
        '<option value="2025">2025</option>' +
        '<option value="2024">2024</option>' +
        '<option value="2023">2023</option>' +
        '<option value="2022">2022</option>' +
        '<option value="2021">2021</option>' +
        '<option value="2020">2020</option>' +
        '<option value="2019">2019</option>' +
        '<option value="2018">2018</option>' +
        '<option value="2017">2017</option>' +
        '<option value="2016">2016</option>' +
        '<option value="2015">2015</option>' +
        '<option value="2014">2014</option>' +
        '<option value="2013">2013</option>' +
        '<option value="2012">2012</option>' +
        '<option value="2011">2011</option>' +
        '<option value="2010">2010</option>' +
        '<option value="2009">2009</option>' +
        '<option value="2008">2008</option>' +
        '<option value="2007">2007</option>' +
        '<option value="2006">2006</option>' +
        '<option value="2005">2005</option>' +
        '<option value="2004">2004</option>' +
        '<option value="2003">2003</option>' +
        '<option value="2002">2002</option>' +
        '<option value="2001">2001</option>' +
        '<option value="2000">2000</option>' +
        '<option value="1999">1999</option>' +
        '<option value="1998">1998</option>' +
        '<option value="1997">1997</option>' +
        '<option value="1996">1996</option>' +
        '<option value="1995">1995</option>' +
        '<option value="1994">1994</option>';
    } else if (model === 'RAM+1500+Classic+Body') {
      document.getElementById('year').disabled = false;
      document.getElementById('year').innerHTML =
        '<option value="none">Select a Year</option>' +
        '<option value="2025">2025</option>' +
        '<option value="2024">2024</option>' +
        '<option value="2023">2023</option>' +
        '<option value="2022">2022</option>' +
        '<option value="2021">2021</option>' +
        '<option value="2020">2020</option>' +
        '<option value="2019">2019</option>' +
        '<option value="2018">2018</option>' +
        '<option value="2017">2017</option>' +
        '<option value="2016">2016</option>' +
        '<option value="2015">2015</option>' +
        '<option value="2014">2014</option>' +
        '<option value="2013">2013</option>' +
        '<option value="2012">2012</option>' +
        '<option value="2011">2011</option>' +
        '<option value="2010">2010</option>' +
        '<option value="2009">2009</option>' +
        '<option value="2008">2008</option>' +
        '<option value="2007">2007</option>' +
        '<option value="2006">2006</option>' +
        '<option value="2005">2005</option>' +
        '<option value="2004">2004</option>' +
        '<option value="2003">2003</option>' +
        '<option value="2002">2002</option>' +
        '<option value="2001">2001</option>' +
        '<option value="2000">2000</option>' +
        '<option value="1999">1999</option>' +
        '<option value="1998">1998</option>' +
        '<option value="1997">1997</option>' +
        '<option value="1996">1996</option>' +
        '<option value="1995">1995</option>' +
        '<option value="1994">1994</option>';
    } else if (model === 'RAM+2500') {
      document.getElementById('year').disabled = false;
      document.getElementById('year').innerHTML =
        '<option value="none">Select a Year</option>' +
        '<option value="2025">2025</option>' +
        '<option value="2024">2024</option>' +
        '<option value="2023">2023</option>' +
        '<option value="2022">2022</option>' +
        '<option value="2021">2021</option>' +
        '<option value="2020">2020</option>' +
        '<option value="2019">2019</option>' +
        '<option value="2018">2018</option>' +
        '<option value="2017">2017</option>' +
        '<option value="2016">2016</option>' +
        '<option value="2015">2015</option>' +
        '<option value="2014">2014</option>' +
        '<option value="2013">2013</option>' +
        '<option value="2012">2012</option>' +
        '<option value="2011">2011</option>' +
        '<option value="2010">2010</option>' +
        '<option value="2009">2009</option>' +
        '<option value="2008">2008</option>' +
        '<option value="2007">2007</option>' +
        '<option value="2006">2006</option>' +
        '<option value="2005">2005</option>' +
        '<option value="2004">2004</option>' +
        '<option value="2003">2003</option>' +
        '<option value="2002">2002</option>' +
        '<option value="2001">2001</option>' +
        '<option value="2000">2000</option>' +
        '<option value="1999">1999</option>' +
        '<option value="1998">1998</option>' +
        '<option value="1997">1997</option>' +
        '<option value="1996">1996</option>' +
        '<option value="1995">1995</option>' +
        '<option value="1994">1994</option>';
    } else if (model === 'RAM+3500') {
      document.getElementById('year').disabled = false;
      document.getElementById('year').innerHTML =
        '<option value="none">Select a Year</option>' +
        '<option value="2025">2025</option>' +
        '<option value="2024">2024</option>' +
        '<option value="2023">2023</option>' +
        '<option value="2022">2022</option>' +
        '<option value="2021">2021</option>' +
        '<option value="2020">2020</option>' +
        '<option value="2019">2019</option>' +
        '<option value="2018">2018</option>' +
        '<option value="2017">2017</option>' +
        '<option value="2016">2016</option>' +
        '<option value="2015">2015</option>' +
        '<option value="2014">2014</option>' +
        '<option value="2013">2013</option>' +
        '<option value="2012">2012</option>' +
        '<option value="2011">2011</option>' +
        '<option value="2010">2010</option>' +
        '<option value="2009">2009</option>' +
        '<option value="2008">2008</option>' +
        '<option value="2007">2007</option>' +
        '<option value="2006">2006</option>' +
        '<option value="2005">2005</option>' +
        '<option value="2004">2004</option>' +
        '<option value="2003">2003</option>' +
        '<option value="2002">2002</option>' +
        '<option value="2001">2001</option>' +
        '<option value="2000">2000</option>' +
        '<option value="1999">1999</option>' +
        '<option value="1998">1998</option>' +
        '<option value="1997">1997</option>' +
        '<option value="1996">1996</option>' +
        '<option value="1995">1995</option>' +
        '<option value="1994">1994</option>';
    } else if (model === 'Avalanche') {
      document.getElementById('year').disabled = false;
      document.getElementById('year').innerHTML =
        '<option value="none">Select a Year</option>' +
        '<option value="2013">2013</option>' +
        '<option value="2012">2012</option>' +
        '<option value="2011">2011</option>' +
        '<option value="2010">2010</option>' +
        '<option value="2009">2009</option>' +
        '<option value="2008">2008</option>' +
        '<option value="2007">2007</option>';
    } else if (model === 'Silverado 1500') {
      document.getElementById('year').disabled = false;
      document.getElementById('year').innerHTML =
        '<option value="none">Select a Year</option>' +
        '<option value="2025">2025</option>' +
        '<option value="2024">2024</option>' +
        '<option value="2023">2023</option>' +
        '<option value="2022">2022</option>' +
        '<option value="2021">2021</option>' +
        '<option value="2020">2020</option>' +
        '<option value="2019">2019</option>' +
        '<option value="2018">2018</option>' +
        '<option value="2017">2017</option>' +
        '<option value="2016">2016</option>' +
        '<option value="2015">2015</option>' +
        '<option value="2014">2014</option>' +
        '<option value="2013">2013</option>' +
        '<option value="2012">2012</option>' +
        '<option value="2011">2011</option>' +
        '<option value="2010">2010</option>' +
        '<option value="2009">2009</option>' +
        '<option value="2008">2008</option>' +
        '<option value="2007">2007</option>' +
        '<option value="2006">2006</option>' +
        '<option value="2005">2005</option>' +
        '<option value="2004">2004</option>' +
        '<option value="2003">2003</option>' +
        '<option value="2002">2002</option>' +
        '<option value="2001">2001</option>' +
        '<option value="2000">2000</option>' +
        '<option value="1999">1999</option>' +
        '<option value="1998">1998</option>' +
        '<option value="1997">1997</option>' +
        '<option value="1996">1996</option>' +
        '<option value="1995">1995</option>' +
        '<option value="1994">1994</option>' +
        '<option value="1993">1993</option>' +
        '<option value="1992">1992</option>' +
        '<option value="1991">1991</option>' +
        '<option value="1990">1990</option>' +
        '<option value="1989">1989</option>' +
        '<option value="1988">1988</option>';
    } else if (model === 'Silverado 2500') {
      document.getElementById('year').disabled = false;
      document.getElementById('year').innerHTML =
        '<option value="none">Select a Year</option>' +
        '<option value="2025">2025</option>' +
        '<option value="2024">2024</option>' +
        '<option value="2023">2023</option>' +
        '<option value="2022">2022</option>' +
        '<option value="2021">2021</option>' +
        '<option value="2020">2020</option>' +
        '<option value="2019">2019</option>' +
        '<option value="2018">2018</option>' +
        '<option value="2017">2017</option>' +
        '<option value="2016">2016</option>' +
        '<option value="2015">2015</option>' +
        '<option value="2014">2014</option>' +
        '<option value="2013">2013</option>' +
        '<option value="2012">2012</option>' +
        '<option value="2011">2011</option>' +
        '<option value="2010">2010</option>' +
        '<option value="2009">2009</option>' +
        '<option value="2008">2008</option>' +
        '<option value="2007">2007</option>' +
        '<option value="2006">2006</option>' +
        '<option value="2005">2005</option>' +
        '<option value="2004">2004</option>' +
        '<option value="2003">2003</option>' +
        '<option value="2002">2002</option>' +
        '<option value="2001">2001</option>' +
        '<option value="2000">2000</option>' +
        '<option value="1999">1999</option>' +
        '<option value="1998">1998</option>' +
        '<option value="1997">1997</option>' +
        '<option value="1996">1996</option>' +
        '<option value="1995">1995</option>' +
        '<option value="1994">1994</option>' +
        '<option value="1993">1993</option>' +
        '<option value="1992">1992</option>' +
        '<option value="1991">1991</option>' +
        '<option value="1990">1990</option>' +
        '<option value="1989">1989</option>' +
        '<option value="1988">1988</option>';
    } else if (model === 'Silverado 3500') {
      document.getElementById('year').disabled = false;
      document.getElementById('year').innerHTML =
        '<option value="none">Select a Year</option>' +
        '<option value="2025">2025</option>' +
        '<option value="2024">2024</option>' +
        '<option value="2023">2023</option>' +
        '<option value="2022">2022</option>' +
        '<option value="2021">2021</option>' +
        '<option value="2020">2020</option>' +
        '<option value="2019">2019</option>' +
        '<option value="2018">2018</option>' +
        '<option value="2017">2017</option>' +
        '<option value="2016">2016</option>' +
        '<option value="2015">2015</option>' +
        '<option value="2014">2014</option>' +
        '<option value="2013">2013</option>' +
        '<option value="2012">2012</option>' +
        '<option value="2011">2011</option>' +
        '<option value="2010">2010</option>' +
        '<option value="2009">2009</option>' +
        '<option value="2008">2008</option>' +
        '<option value="2007">2007</option>' +
        '<option value="2006">2006</option>' +
        '<option value="2005">2005</option>' +
        '<option value="2004">2004</option>' +
        '<option value="2003">2003</option>' +
        '<option value="2002">2002</option>' +
        '<option value="2001">2001</option>' +
        '<option value="2000">2000</option>' +
        '<option value="1999">1999</option>' +
        '<option value="1998">1998</option>' +
        '<option value="1997">1997</option>' +
        '<option value="1996">1996</option>' +
        '<option value="1995">1995</option>' +
        '<option value="1994">1994</option>' +
        '<option value="1993">1993</option>' +
        '<option value="1992">1992</option>' +
        '<option value="1991">1991</option>' +
        '<option value="1990">1990</option>' +
        '<option value="1989">1989</option>' +
        '<option value="1988">1988</option>';
    } else if (model === 'Silverado 3500 Dually') {
      document.getElementById('year').disabled = false;
      document.getElementById('year').innerHTML =
        '<option value="none">Select a Year</option>' +
        '<option value="2025">2025</option>' +
        '<option value="2024">2024</option>' +
        '<option value="2023">2023</option>' +
        '<option value="2022">2022</option>' +
        '<option value="2021">2021</option>' +
        '<option value="2020">2020</option>' +
        '<option value="2019">2019</option>' +
        '<option value="2018">2018</option>' +
        '<option value="2017">2017</option>' +
        '<option value="2016">2016</option>' +
        '<option value="2015">2015</option>' +
        '<option value="2014">2014</option>' +
        '<option value="2013">2013</option>' +
        '<option value="2012">2012</option>' +
        '<option value="2011">2011</option>' +
        '<option value="2010">2010</option>' +
        '<option value="2009">2009</option>' +
        '<option value="2008">2008</option>' +
        '<option value="2007">2007</option>' +
        '<option value="2006">2006</option>' +
        '<option value="2005">2005</option>' +
        '<option value="2004">2004</option>' +
        '<option value="2003">2003</option>' +
        '<option value="2002">2002</option>' +
        '<option value="2001">2001</option>' +
        '<option value="2000">2000</option>' +
        '<option value="1999">1999</option>' +
        '<option value="1998">1998</option>' +
        '<option value="1997">1997</option>' +
        '<option value="1996">1996</option>' +
        '<option value="1995">1995</option>' +
        '<option value="1994">1994</option>' +
        '<option value="1993">1993</option>' +
        '<option value="1992">1992</option>' +
        '<option value="1991">1991</option>' +
        '<option value="1990">1990</option>' +
        '<option value="1989">1989</option>' +
        '<option value="1988">1988</option>';
    } else if (model === 'Silverado') {
      document.getElementById('year').disabled = false;
      document.getElementById('year').innerHTML =
        '<option value="none">Select a Year</option>' +
        '<option value="2025">2025</option>' +
        '<option value="2024">2024</option>' +
        '<option value="2023">2023</option>' +
        '<option value="2022">2022</option>' +
        '<option value="2021">2021</option>' +
        '<option value="2020">2020</option>' +
        '<option value="2019">2019</option>' +
        '<option value="2018">2018</option>' +
        '<option value="2017">2017</option>' +
        '<option value="2016">2016</option>' +
        '<option value="2015">2015</option>' +
        '<option value="2014">2014</option>' +
        '<option value="2013">2013</option>' +
        '<option value="2012">2012</option>' +
        '<option value="2011">2011</option>' +
        '<option value="2010">2010</option>' +
        '<option value="2009">2009</option>' +
        '<option value="2008">2008</option>' +
        '<option value="2007">2007</option>' +
        '<option value="2006">2006</option>' +
        '<option value="2005">2005</option>' +
        '<option value="2004">2004</option>' +
        '<option value="2003">2003</option>' +
        '<option value="2002">2002</option>' +
        '<option value="2001">2001</option>' +
        '<option value="2000">2000</option>' +
        '<option value="1999">1999</option>' +
        '<option value="1998">1998</option>' +
        '<option value="1997">1997</option>' +
        '<option value="1996">1996</option>' +
        '<option value="1995">1995</option>' +
        '<option value="1994">1994</option>' +
        '<option value="1993">1993</option>' +
        '<option value="1992">1992</option>' +
        '<option value="1991">1991</option>' +
        '<option value="1990">1990</option>' +
        '<option value="1989">1989</option>' +
        '<option value="1988">1988</option>';
    } else if (model === 'Suburban') {
      document.getElementById('year').disabled = false;
      document.getElementById('year').innerHTML =
        '<option value="none">Select a Year</option>' +
        '<option value="2025">2025</option>' +
        '<option value="2024">2024</option>' +
        '<option value="2023">2023</option>' +
        '<option value="2022">2022</option>' +
        '<option value="2021">2021</option>' +
        '<option value="2020">2020</option>' +
        '<option value="2019">2019</option>' +
        '<option value="2018">2018</option>' +
        '<option value="2017">2017</option>' +
        '<option value="2016">2016</option>' +
        '<option value="2015">2015</option>' +
        '<option value="2014">2014</option>' +
        '<option value="2013">2013</option>' +
        '<option value="2012">2012</option>' +
        '<option value="2011">2011</option>' +
        '<option value="2010">2010</option>' +
        '<option value="2009">2009</option>' +
        '<option value="2008">2008</option>' +
        '<option value="2007">2007</option>' +
        '<option value="2006">2006</option>' +
        '<option value="2005">2005</option>' +
        '<option value="2004">2004</option>' +
        '<option value="2003">2003</option>' +
        '<option value="2002">2002</option>' +
        '<option value="2001">2001</option>' +
        '<option value="2000">2000</option>';
    } else if (model === 'Tahoe') {
      document.getElementById('year').disabled = false;
      document.getElementById('year').innerHTML =
        '<option value="none">Select a Year</option>' +
        '<option value="2025">2025</option>' +
        '<option value="2024">2024</option>' +
        '<option value="2023">2023</option>' +
        '<option value="2022">2022</option>' +
        '<option value="2021">2021</option>' +
        '<option value="2020">2020</option>' +
        '<option value="2019">2019</option>' +
        '<option value="2018">2018</option>' +
        '<option value="2017">2017</option>' +
        '<option value="2016">2016</option>' +
        '<option value="2015">2015</option>' +
        '<option value="2014">2014</option>' +
        '<option value="2013">2013</option>' +
        '<option value="2012">2012</option>' +
        '<option value="2011">2011</option>' +
        '<option value="2010">2010</option>' +
        '<option value="2009">2009</option>' +
        '<option value="2008">2008</option>' +
        '<option value="2007">2007</option>' +
        '<option value="2006">2006</option>' +
        '<option value="2005">2005</option>' +
        '<option value="2004">2004</option>' +
        '<option value="2003">2003</option>' +
        '<option value="2002">2002</option>' +
        '<option value="2001">2001</option>' +
        '<option value="2000">2000</option>';
    } else if (model === 'Sierra+1500') {
      document.getElementById('year').disabled = false;
      document.getElementById('year').innerHTML =
        '<option value="none">Select a Year</option>' +
        '<option value="2025">2025</option>' +
        '<option value="2024">2024</option>' +
        '<option value="2023">2023</option>' +
        '<option value="2022">2022</option>' +
        '<option value="2021">2021</option>' +
        '<option value="2020">2020</option>' +
        '<option value="2019">2019</option>' +
        '<option value="2018">2018</option>' +
        '<option value="2017">2017</option>' +
        '<option value="2016">2016</option>' +
        '<option value="2015">2015</option>' +
        '<option value="2014">2014</option>' +
        '<option value="2013">2013</option>' +
        '<option value="2012">2012</option>' +
        '<option value="2011">2011</option>' +
        '<option value="2010">2010</option>' +
        '<option value="2009">2009</option>' +
        '<option value="2008">2008</option>' +
        '<option value="2007">2007</option>' +
        '<option value="2006">2006</option>' +
        '<option value="2005">2005</option>' +
        '<option value="2004">2004</option>' +
        '<option value="2003">2003</option>' +
        '<option value="2002">2002</option>' +
        '<option value="2001">2001</option>' +
        '<option value="2000">2000</option>' +
        '<option value="1999">1999</option>' +
        '<option value="1998">1998</option>' +
        '<option value="1997">1997</option>' +
        '<option value="1996">1996</option>' +
        '<option value="1995">1995</option>' +
        '<option value="1994">1994</option>';
    } else if (model === 'Sierra+2500') {
      document.getElementById('year').disabled = false;
      document.getElementById('year').innerHTML =
        '<option value="none">Select a Year</option>' +
        '<option value="2025">2025</option>' +
        '<option value="2024">2024</option>' +
        '<option value="2023">2023</option>' +
        '<option value="2022">2022</option>' +
        '<option value="2021">2021</option>' +
        '<option value="2020">2020</option>' +
        '<option value="2019">2019</option>' +
        '<option value="2018">2018</option>' +
        '<option value="2017">2017</option>' +
        '<option value="2016">2016</option>' +
        '<option value="2015">2015</option>' +
        '<option value="2014">2014</option>' +
        '<option value="2013">2013</option>' +
        '<option value="2012">2012</option>' +
        '<option value="2011">2011</option>' +
        '<option value="2010">2010</option>' +
        '<option value="2009">2009</option>' +
        '<option value="2008">2008</option>' +
        '<option value="2007">2007</option>' +
        '<option value="2006">2006</option>' +
        '<option value="2005">2005</option>' +
        '<option value="2004">2004</option>' +
        '<option value="2003">2003</option>' +
        '<option value="2002">2002</option>' +
        '<option value="2001">2001</option>' +
        '<option value="2000">2000</option>' +
        '<option value="1999">1999</option>' +
        '<option value="1998">1998</option>' +
        '<option value="1997">1997</option>' +
        '<option value="1996">1996</option>' +
        '<option value="1995">1995</option>' +
        '<option value="1994">1994</option>';
    } else if (model === 'Sierra+3500') {
      document.getElementById('year').disabled = false;
      document.getElementById('year').innerHTML =
        '<option value="none">Select a Year</option>' +
        '<option value="2025">2025</option>' +
        '<option value="2024">2024</option>' +
        '<option value="2023">2023</option>' +
        '<option value="2022">2022</option>' +
        '<option value="2021">2021</option>' +
        '<option value="2020">2020</option>' +
        '<option value="2019">2019</option>' +
        '<option value="2018">2018</option>' +
        '<option value="2017">2017</option>' +
        '<option value="2016">2016</option>' +
        '<option value="2015">2015</option>' +
        '<option value="2014">2014</option>' +
        '<option value="2013">2013</option>' +
        '<option value="2012">2012</option>' +
        '<option value="2011">2011</option>' +
        '<option value="2010">2010</option>' +
        '<option value="2009">2009</option>' +
        '<option value="2008">2008</option>' +
        '<option value="2007">2007</option>' +
        '<option value="2006">2006</option>' +
        '<option value="2005">2005</option>' +
        '<option value="2004">2004</option>' +
        '<option value="2003">2003</option>' +
        '<option value="2002">2002</option>' +
        '<option value="2001">2001</option>' +
        '<option value="2000">2000</option>' +
        '<option value="1999">1999</option>' +
        '<option value="1998">1998</option>' +
        '<option value="1997">1997</option>' +
        '<option value="1996">1996</option>' +
        '<option value="1995">1995</option>' +
        '<option value="1994">1994</option>';
    } else if (model === 'Sierra+3500+Dually') {
      document.getElementById('year').disabled = false;
      document.getElementById('year').innerHTML =
        '<option value="none">Select a Year</option>' +
        '<option value="2025">2025</option>' +
        '<option value="2024">2024</option>' +
        '<option value="2023">2023</option>' +
        '<option value="2022">2022</option>' +
        '<option value="2021">2021</option>' +
        '<option value="2020">2020</option>' +
        '<option value="2019">2019</option>' +
        '<option value="2018">2018</option>' +
        '<option value="2017">2017</option>' +
        '<option value="2016">2016</option>' +
        '<option value="2015">2015</option>' +
        '<option value="2014">2014</option>' +
        '<option value="2013">2013</option>' +
        '<option value="2012">2012</option>' +
        '<option value="2011">2011</option>' +
        '<option value="2010">2010</option>' +
        '<option value="2009">2009</option>' +
        '<option value="2008">2008</option>' +
        '<option value="2007">2007</option>' +
        '<option value="2006">2006</option>' +
        '<option value="2005">2005</option>' +
        '<option value="2004">2004</option>' +
        '<option value="2003">2003</option>' +
        '<option value="2002">2002</option>' +
        '<option value="2001">2001</option>' +
        '<option value="2000">2000</option>' +
        '<option value="1999">1999</option>' +
        '<option value="1998">1998</option>' +
        '<option value="1997">1997</option>' +
        '<option value="1996">1996</option>' +
        '<option value="1995">1995</option>' +
        '<option value="1994">1994</option>';
    } else if (model === 'Sierra') {
      document.getElementById('year').disabled = false;
      document.getElementById('year').innerHTML =
        '<option value="none">Select a Year</option>' +
        '<option value="2025">2025</option>' +
        '<option value="2024">2024</option>' +
        '<option value="2023">2023</option>' +
        '<option value="2022">2022</option>' +
        '<option value="2021">2021</option>' +
        '<option value="2020">2020</option>' +
        '<option value="2019">2019</option>' +
        '<option value="2018">2018</option>' +
        '<option value="2017">2017</option>' +
        '<option value="2016">2016</option>' +
        '<option value="2015">2015</option>' +
        '<option value="2014">2014</option>' +
        '<option value="2013">2013</option>' +
        '<option value="2012">2012</option>' +
        '<option value="2011">2011</option>' +
        '<option value="2010">2010</option>' +
        '<option value="2009">2009</option>' +
        '<option value="2008">2008</option>' +
        '<option value="2007">2007</option>' +
        '<option value="2006">2006</option>' +
        '<option value="2005">2005</option>' +
        '<option value="2004">2004</option>' +
        '<option value="2003">2003</option>' +
        '<option value="2002">2002</option>' +
        '<option value="2001">2001</option>' +
        '<option value="2000">2000</option>' +
        '<option value="1999">1999</option>' +
        '<option value="1998">1998</option>' +
        '<option value="1997">1997</option>' +
        '<option value="1996">1996</option>' +
        '<option value="1995">1995</option>' +
        '<option value="1994">1994</option>' +
        '<option value="1993">1993</option>' +
        '<option value="1992">1992</option>' +
        '<option value="1991">1991</option>' +
        '<option value="1990">1990</option>' +
        '<option value="1989">1989</option>' +
        '<option value="1988">1988</option>';
    } else if (model === 'Yukon') {
      document.getElementById('year').disabled = false;
      document.getElementById('year').innerHTML =
        '<option value="none">Select a Year</option>' +
        '<option value="2011">2011</option>' +
        '<option value="2010">2010</option>' +
        '<option value="2009">2009</option>' +
        '<option value="2008">2008</option>' +
        '<option value="2007">2007</option>' +
        '<option value="2006">2006</option>' +
        '<option value="2005">2005</option>' +
        '<option value="2004">2004</option>' +
        '<option value="2003">2003</option>' +
        '<option value="2002">2002</option>' +
        '<option value="2001">2001</option>' +
        '<option value="2000">2000</option>';
    } else if (model === 'Yukon XL') {
      document.getElementById('year').disabled = false;
      document.getElementById('year').innerHTML =
        '<option value="none">Select a Year</option>' +
        '<option value="2025">2025</option>' +
        '<option value="2024">2024</option>' +
        '<option value="2023">2023</option>' +
        '<option value="2022">2022</option>' +
        '<option value="2021">2021</option>';
    } else if (model === 'Yukon Denali') {
      document.getElementById('year').disabled = false;
      document.getElementById('year').innerHTML =
        '<option value="none">Select a Year</option>' +
        '<option value="2025">2025</option>' +
        '<option value="2024">2024</option>' +
        '<option value="2023">2023</option>' +
        '<option value="2022">2022</option>' +
        '<option value="2021">2021</option>';
    } else if (model === 'Wrangler') {
      document.getElementById('year').disabled = false;
      document.getElementById('year').innerHTML =
        '<option value="none">Select a Year</option>' +
        '<option value="2025">2025</option>' +
        '<option value="2024">2024</option>' +
        '<option value="2023">2023</option>' +
        '<option value="2022">2022</option>' +
        '<option value="2021">2021</option>' +
        '<option value="2020">2020</option>' +
        '<option value="2019">2019</option>' +
        '<option value="2018">2018</option>' +
        '<option value="2017">2017</option>' +
        '<option value="2016">2016</option>' +
        '<option value="2015">2015</option>' +
        '<option value="2014">2014</option>' +
        '<option value="2013">2013</option>' +
        '<option value="2012">2012</option>' +
        '<option value="2011">2011</option>' +
        '<option value="2010">2010</option>' +
        '<option value="2009">2009</option>' +
        '<option value="2008">2008</option>' +
        '<option value="2007">2007</option>';
    } else if (model === 'Wrangler+JL') {
      document.getElementById('year').disabled = false;
      document.getElementById('year').innerHTML =
        '<option value="none">Select a Year</option>' +
        '<option value="2025">2025</option>' +
        '<option value="2024">2024</option>' +
        '<option value="2023">2023</option>' +
        '<option value="2022">2022</option>' +
        '<option value="2021">2021</option>' +
        '<option value="2020">2020</option>' +
        '<option value="2019">2019</option>' +
        '<option value="2018">2018</option>';
    } else if (model === 'Wrangler+JK') {
      document.getElementById('year').disabled = false;
      document.getElementById('year').innerHTML =
        '<option value="none">Select a Year</option>' +
        '<option value="2018">2018</option>' +
        '<option value="2017">2017</option>' +
        '<option value="2016">2016</option>' +
        '<option value="2015">2015</option>' +
        '<option value="2014">2014</option>' +
        '<option value="2013">2013</option>' +
        '<option value="2012">2012</option>' +
        '<option value="2011">2011</option>' +
        '<option value="2010">2010</option>' +
        '<option value="2009">2009</option>' +
        '<option value="2008">2008</option>' +
        '<option value="2007">2007</option>';
    } else if (model === 'gladiator') {
      document.getElementById('year').disabled = false;
      document.getElementById('year').innerHTML =
        '<option value="none">Select a Year</option>' +
        '<option value="2025">2025</option>' +
        '<option value="2024">2024</option>' +
        '<option value="2023">2023</option>' +
        '<option value="2022">2022</option>' +
        '<option value="2021">2021</option>' +
        '<option value="2020">2020</option>' +
        '<option value="2019">2019</option>' +
        '<option value="2018">2018</option>';
    } else if (model === 'Tacoma') {
      document.getElementById('year').disabled = false;
      document.getElementById('year').innerHTML =
        '<option value="none">Select a Year</option>' +
        '<option value="2025">2025</option>' +
        '<option value="2024">2024</option>' +
        '<option value="2023">2023</option>' +
        '<option value="2022">2022</option>' +
        '<option value="2021">2021</option>' +
        '<option value="2020">2020</option>' +
        '<option value="2019">2019</option>' +
        '<option value="2018">2018</option>' +
        '<option value="2017">2017</option>' +
        '<option value="2016">2016</option>' +
        '<option value="2015">2015</option>' +
        '<option value="2014">2014</option>' +
        '<option value="2013">2013</option>' +
        '<option value="2012">2012</option>' +
        '<option value="2011">2011</option>' +
        '<option value="2010">2010</option>' +
        '<option value="2009">2009</option>' +
        '<option value="2008">2008</option>' +
        '<option value="2007">2007</option>' +
        '<option value="2006">2006</option>' +
        '<option value="2005">2005</option>' +
        '<option value="2004">2004</option>' +
        '<option value="2003">2003</option>' +
        '<option value="2002">2002</option>' +
        '<option value="2001">2001</option>' +
        '<option value="2000">2000</option>' +
        '<option value="1999">1999</option>' +
        '<option value="1998">1998</option>' +
        '<option value="1997">1997</option>' +
        '<option value="1996">1996</option>' +
        '<option value="1995">1995</option>';
    } else if (model === 'Tundra') {
      document.getElementById('year').disabled = false;
      document.getElementById('year').innerHTML =
        '<option value="none">Select a Year</option>' +
        '<option value="2025">2025</option>' +
        '<option value="2024">2024</option>' +
        '<option value="2023">2023</option>' +
        '<option value="2022">2022</option>' +
        '<option value="2021">2021</option>' +
        '<option value="2020">2020</option>' +
        '<option value="2019">2019</option>' +
        '<option value="2018">2018</option>' +
        '<option value="2017">2017</option>' +
        '<option value="2016">2016</option>' +
        '<option value="2015">2015</option>' +
        '<option value="2014">2014</option>' +
        '<option value="2013">2013</option>' +
        '<option value="2012">2012</option>' +
        '<option value="2011">2011</option>' +
        '<option value="2010">2010</option>' +
        '<option value="2009">2009</option>' +
        '<option value="2008">2008</option>' +
        '<option value="2007">2007</option>' +
        '<option value="2006">2006</option>' +
        '<option value="2005">2005</option>' +
        '<option value="2004">2004</option>' +
        '<option value="2003">2003</option>' +
        '<option value="2002">2002</option>' +
        '<option value="2001">2001</option>' +
        '<option value="2000">2000</option>' +
        '<option value="1999">1999</option>' +
        '<option value="1998">1998</option>' +
        '<option value="1997">1997</option>' +
        '<option value="1996">1996</option>' +
        '<option value="1995">1995</option>';
    } else if (model === 'Sequoia') {
      document.getElementById('year').disabled = false;
      document.getElementById('year').innerHTML =
        '<option value="none">Select a Year</option>' +
        '<option value="2013">2013</option>' +
        '<option value="2012">2012</option>' +
        '<option value="2011">2011</option>' +
        '<option value="2010">2010</option>' +
        '<option value="2009">2009</option>' +
        '<option value="2008">2008</option>' +
        '<option value="2007">2007</option>' +
        '<option value="2006">2006</option>' +
        '<option value="2005">2005</option>' +
        '<option value="2004">2004</option>' +
        '<option value="2003">2003</option>' +
        '<option value="2002">2002</option>' +
        '<option value="2001">2001</option>' +
        '<option value="2000">2000</option>' +
        '<option value="1999">1999</option>' +
        '<option value="1998">1998</option>' +
        '<option value="1997">1997</option>' +
        '<option value="1996">1996</option>' +
        '<option value="1995">1995</option>';
    } else if (model === 'H2') {
      document.getElementById('year').disabled = false;
      document.getElementById('year').innerHTML =
        '<option value="none">Select a Year</option>' +
        '<option value="2010">2010</option>' +
        '<option value="2009">2009</option>' +
        '<option value="2008">2008</option>' +
        '<option value="2007">2007</option>' +
        '<option value="2006">2006</option>' +
        '<option value="2005">2005</option>' +
        '<option value="2004">2004</option>' +
        '<option value="2003">2003</option>' +
        '<option value="2002">2002</option>';
    } else if (model === 'Escalade') {
      document.getElementById('year').disabled = false;
      document.getElementById('year').innerHTML =
        '<option value="none">Select a Year</option>' +
        '<option value="2025">2025</option>' +
        '<option value="2024">2024</option>' +
        '<option value="2023">2023</option>' +
        '<option value="2022">2022</option>' +
        '<option value="2021">2021</option>';
    } else {
      document.getElementById('year').disabled = true;
      document.getElementById('year').innerHTML = '<option value="none">Select a Year</option>';
    }
  }
  document.getElementById('model').addEventListener('change', onModelChange);

  function onYearChange() {
    var model = document.getElementById('year').value;
    if (model !== '') {
      document.getElementById('sbbutton').disabled = false;
      var make = document.getElementById('make').value;
      var model = document.getElementById('model').value;
      var year = document.getElementById('year').value;
      var filterurl =
        '/collections/all?&filter.p.m.custom.make=' +
        make +
        '&filter.p.m.custom.vehicle_model=' +
        model +
        '&filter.p.m.custom.vehicle_year=' +
        year;
      document.getElementById('sbbutton').dataset.redirect = filterurl;
    } else {
      document.getElementById('sbbutton').disabled = true;
    }
  }
  document.getElementById('year').addEventListener('change', onYearChange);

  function redirectToDataUrl(event) {
    var button = event.target;
    var url = button.dataset.redirect;
    window.location.href = url;
  }